


































































import { Mixins, Component } from 'vue-property-decorator'
import MixinForm from 'components/presenter/item/topic/editor/MixinForm'
import FormSlide from 'components/presenter/item/topic/editor/FormSlide.vue'
import IntegerInput from 'components/IntegerInput.vue'

@Component({
  components: {
    FormSlide,
    IntegerInput
  }
})
export default class ItemTopicSlidesEditorFormEssay extends Mixins(MixinForm) {
}
